import { ListOfStatesResponse } from './Api/ListOfStatesResponse';

export class StateEntity extends ListOfStatesResponse {
	public static tryCast(o: any): StateEntity {
		const ret = new StateEntity();
		return Object.assign(ret, o);
	}
}
